import $ from "jquery";
import _ from "underscore";
import View from './View';
import messageResource from "./messageResource";

const isPrototypeOfDefined = Object.getPrototypeOf;

/**
 * Implementation of View class, which uses Underscore or plain HTML strings as templates for rendering.
 * @param $containerEl - element for render component
 * @constructor
 */
export default class TemplateView extends View
{
    constructor($containerEl)
    {
        super($containerEl);
    }

    /**
     * HTML template or just plain markup used to render the view.
     */
    templateHtml()
    {
        // TODO: Eventually make this abstract, or empty div. Legacy TemplateView classes have their markup in the "html" field, so this line is for them.
        return this["html"];
    }

    /**
     * Defines if a view should use Underscore templates functionality.
     * If template HTML is static, it would be beneficial to set this to false.
     * @return {boolean}
     */
    useUnderscoreTemplate()
    {
        return true;
    }

    render()
    {
        if (!this.$el)
            this.$el = $(this.toHtml());
        this.appendToContainer();
        return this;
    }

    appendToContainer()
    {
        this.$containerEl.append(this.$el);
    }

    toHtml()
    {
        if (!this._htmlCache)
            this._htmlCache = this._toHtml();
        return this._htmlCache;
    }

    _toHtml()
    {
        let html;
        if (this.useUnderscoreTemplate())
        {
            let template;
            if (isPrototypeOfDefined)
            {
                template = Object.getPrototypeOf(this)._cachedTemplate;
                if (!template)
                {
                    template = _.template(this.templateHtml());
                    Object.getPrototypeOf(this)._cachedTemplate = template;
                }

            }
            else
            {
                template = _.template(this.templateHtml());
            }

            const model = this.templateModel();
            const messageKeys = this.messageKeys();
            _.each(_.keys(messageKeys), (modelKey) => model[modelKey] = messageResource.getMessage(messageKeys[modelKey]));
            html = template(model);
        }
        else
            html = this.templateHtml();

        return html;
    }

    /**
     * When TemplateView is rendered using Underscore template,
     * this function's returned object will be used as a model.
     * @returns {Object}
     */
    templateModel()
    {
        return this;
    }

    /**
     * Works similarly to .templateModel() method, but interprets object keys as messageKeys
     * for messageResource, which will be exchanged to actual message strings during render.
     * @returns {Object}
     */
    messageKeys()
    {
        return {};
    }
}



// WEBPACK FOOTER //
// ./web/js/TemplateView.js